// code executed on create and edit pages
$(document).ready(/\/faculty-management\/locker\/([0-9]+\/)?(create|edit)/
    .test(window.location.pathname)&&function() {

  const status = $('[name="status"]');
  const ownerType = $('[name="ownerType"]');
  const student = $('[name="student"]');
  const employee = $('[name="employee"]');
  const showCorrespondingInput = function() {
    if (ownerType.val() === 'employee') {
      student.closest('div[class^="col"]').hide();
      employee.closest('div[class^="col"]').show();
    } else {
      employee.closest('div[class^="col"]').hide();
      student.closest('div[class^="col"]').show();
    }
  };

  ownerType.on('change', function() {
    showCorrespondingInput();
  });
  showCorrespondingInput();

  // code executed only on create page
  if (/\/faculty-management\/locker\/create/.test(window.location.pathname)) {
    const disableSelectElement = function(element) {
      element[0].choices.disable();
    };
    const enableSelectElement = function(element) {
      element[0].choices.enable();
    };
    const toggleDisabledOnStatusChange = function() {
      const depositDate = $('[name="depositDate"]');
      if (status.val() === 'free') {
        disableSelectElement(ownerType);
        disableSelectElement(student);
        disableSelectElement(employee);
        depositDate.prop('disabled', true);
      } else {
        enableSelectElement(ownerType);
        enableSelectElement(student);
        enableSelectElement(employee);
        depositDate.prop('disabled', false);
      }
      showCorrespondingInput();
    };
    status.on('change', function() {
      toggleDisabledOnStatusChange();
    });
    toggleDisabledOnStatusChange();
  }
});
